module.exports = __webpack_public_path__ + "img/MZ.d5df5751.png";